<template>
  <div class="goods">
    <!--<van-nav-bar title="爱车估值" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>-->

    <!--<img style="width: 100%" src="https://images.unsplash.com/photo-1551334787-21e6bd3ab135?w=640" alt="">-->
    <img src="../../image/banner.png" alt="" style="width: 100%">

    <div style="padding: 0 .324rem">
      <van-cell-group style="box-shadow: 0px 0px 0.27rem 0px rgba(0, 0, 0, 0.08);border-radius: .27rem;margin-top: -.8rem;overflow: hidden">
        <van-field class="flex-start" v-model="brand" disabled label="选择车型" placeholder="请选择" @click="bind"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>
        <van-field class="flex-start" v-model="time" disabled label="上牌时间" placeholder="请选择" @click="showTime=true;"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>
        <van-field class="flex-start" v-model="mileage" type="number" maxlength="6" label="行驶里程" placeholder="请填写行驶里程" @input="toMember" onfocus="this.placeholder=' '" onblur="this.placeholder='请填写行驶里程'"><template v-slot:right-icon>万公里</template></van-field>
        <van-field class="flex-start" v-model="assessment" disabled label="车况自评" placeholder="请选择" @click="showAssessment=true;"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>
        <!--<van-field class="flex-start" v-model="city" disabled label="卖车城市" placeholder="请选择" @click="show=true;"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>-->
        <van-field class="flex-start" v-model="city" disabled label="卖车城市" placeholder="请选择" @click="showCity=true;"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>
        <van-field class="flex-start" v-model="phone" type="number" label="联系电话" maxlength="11" placeholder="请填写联系电话"/>
      </van-cell-group>
    </div>

    <div class="flex-center" style="color: #F7932B;font-size: .324rem;margin: 1.431rem 0 .324rem">*评估结果数据仅供个人参考</div>
    <div class="flex-center" style="width: 100%;margin-bottom: .378rem;">
      <div class="flex-center" style="background:linear-gradient(90deg,rgba(241,39,12,1) 0%,rgba(255,68,19,1) 100%);color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toValuation">一键估值</div>
    </div>

    <!--选择城市弹框-->
    <van-popup v-model="showCity" position="bottom">
      <div class="van-hairline--top-bottom van-picker__toolbar"><button class="van-picker__cancel" @click="showCity=false;">取消</button><button class="van-picker__confirm" @click="carCity">确认</button></div>
      <div class="flex-start" style="width: 100%">
        <van-picker :columns="mainCity" @change="mainCityTo" style="width: 50%"/>
        <van-picker :columns="mainProvinces" @change="mainProvincesTo" style="width: 50%"/>
      </div>
    </van-popup>

    <!--选择车况自评-->
    <van-popup v-model="showAssessment" position="bottom" >
      <div style="height: 1.17rem;line-height: 1.17rem;position: relative;font-size:14px;font-weight:bold;text-align: center">车况自评</div>
      <div v-for="item in modeAssessment">
        <div class="flex-start" style="line-height: 1rem;">
          <div style="font-size: 14px;font-weight: 500;width: 2rem;padding-left: .5rem;">{{item.name}}</div>
          <van-rate v-model="item.showValue" :size="25" :count="5" :gutter="10" :icon="xinxinl" :void-icon="xinxinm"/>
        </div>
        <div v-if="item.name=='内饰评分'">
          <div v-if="item.showValue==1" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">内饰脏，异味刺鼻，有重度破损，及多处功能按键损坏</div>
          <div v-else-if="item.showValue==2" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">内饰有明显划伤、异味，多处磨损造成的龟裂、褶皱</div>
          <div v-else-if="item.showValue==3" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">内饰较干净无明显异味，有少处划伤或明显磨损</div>
          <div v-else-if="item.showValue==4" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">内饰无异味，有轻微划痕或污渍，可抛光打蜡处理</div>
          <div v-else-if="item.showValue==5" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">内饰崭新无异味，无任何划擦或明显污渍，浸泡，破损</div>
          <div v-else style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;"></div>
        </div>
        <div v-else-if="item.name=='外观评分'">
          <div v-if="item.showValue==1" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">全车喷漆质量差，有多处划痕，大面积的擦伤凹陷等</div>
          <div v-else-if="item.showValue==2" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">喷漆面积超过四个面以上，有中度划痕或凹塘，需整修</div>
          <div v-else-if="item.showValue==3" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">喷漆面积超过两个面以上，有多处轻微划痕和轻微凹陷</div>
          <div v-else-if="item.showValue==4" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">全车原漆，仅有轻微划痕，少处轻微凹陷</div>
          <div v-else-if="item.showValue==5" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">全车原漆、有轻微划痕，无任何凹陷</div>
          <div v-else style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;"></div>
        </div>
        <div v-else-if="item.name=='车况评分'">
          <div v-if="item.showValue==1" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">发动机严重烧机油；发动机及变速箱渗油及异响严重</div>
          <div v-else-if="item.showValue==2" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">发动机曾修复或曾更换；变速箱排挡不顺畅</div>
          <div v-else-if="item.showValue==3" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">发动机抖动明显；发动机及变速箱渗油</div>
          <div v-else-if="item.showValue==4" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">发动机轻微抖动、发动机及变速箱轻微渗油</div>
          <div v-else-if="item.showValue==5" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">发动机正常、变速箱正常</div>
          <div v-else style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;"></div>
        </div>
        <div v-else-if="item.name=='骨架结构'">
          <div v-if="item.showValue==1" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">乘员舱底板有碰撞；上边梁、车顶、框架等多出有切割</div>
          <div v-else-if="item.showValue==2" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">气囊爆过；车身立柱、框架等多处有切割</div>
          <div v-else-if="item.showValue==3" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">水箱框架、 翼内板、导水槽、下边梁等有切割</div>
          <div v-else-if="item.showValue==4" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">前后横梁有整形或更换</div>
          <div v-else-if="item.showValue==5" style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;">结构正常</div>
          <div v-else style="padding-left: 2.5rem;font-size: 12px;color: #FF713D;line-height: 13px;min-height: .5rem;"></div>
        </div>
      </div>
      <div class="flex-center" style="width: 100%;margin-top: .8rem;">
        <div class="flex-center" style="margin: .21rem auto;background:linear-gradient(90deg,rgba(241,39,12,1) 0%,rgba(255,68,19,1) 100%);color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toShowAssessment">确认</div>
      </div>
    </van-popup>

    <!--上牌时间弹框-->
    <van-popup v-model="showTime" position="bottom" >
      <van-datetime-picker  type="date" :max-date="currentTime" @cancel="showTime=false;" @confirm="onConfirmTime"/>
    </van-popup>

    <!--选择品牌弹框-->
    <van-popup v-model="show2" position="right" :style="{ height: '100%',with :'100%',left: '0'}">
      <div class="carDetali">
        <div class="carFor" v-for="item in carDetali">
          <div class="carTitle">{{item.letter}}</div>
          <ul>
            <li class="flex-start" v-for="list in item.mian" @click="trademark(list.brandId,list.brandLogo,list.brandName)">
              <span style="margin: 0 .3rem;display: flex;"><img :src="list.brandLogo" alt=""></span>
              <div>{{list.brandName}}</div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>

    <!--选择车系弹框-->
    <van-popup v-model="show3" position="right" :style="{ height: '100%',width: '65%'}">
      <div class="carDetali2">
        <div class="carFor" v-for="item in carDetali2">
          <div class="carTitle flex-start">
            <img :src="brandLogoe" alt="">
            <div>{{item.factoryName}}</div>
          </div>
          <ul>
            <li v-for="list in item.seriesList" @click="Vehicle(list.id )">
              <div>{{list.familyname}}</div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>

    <!--选择车型弹框-->
    <van-popup v-model="show4" position="right" :style="{ height: '100%',with :'100%',left: '0'}">
      <div class="carDetali3">
        <div class="carFor" v-for="item in carDetali3">
          <div class="carTitle">{{item.year}}</div>
          <ul>
            <li v-for="list in item.modelList" @click="models(list.autohomeid ,list.salesdesc)">{{list.salesdesc}}</li>
          </ul>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
    import {
        NavBar,
        Icon,
        Field,
        Popup,
        CellGroup,
        Picker,
        Toast,
        DatetimePicker,
        Area,
        Rate
    } from 'vant';

    import request from '@/utils/request'
    import area from '@/utils/area'

    import xinxinl from '../../image/xinxinl.png';
    import xinxinm from '../../image/xinxinm.png';

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [CellGroup.name]: CellGroup,
            [Picker.name]: Picker,
            [Toast.name]: Toast,
            [DatetimePicker.name]: DatetimePicker,
            [Area.name]: Area,
            [Rate.name]: Rate
        },

        data() {
            return {
                currentTime: new Date(),
                startTime: new Date(),
                minDate: new Date(),
                showTime: false,
                show: false,
                show2: false,
                show3: false,
                show4: false,
                showCity:false,
                mainCity:[],
                mainProvinces:[],
                provId:[{idCity:"",name:""},{idProvinces:"",name:""}],
                provId2:[{idCity:"",name:""},{idProvinces:"",name:""}],
                detailCity:[],
                detailProvinces:[],
                brand:"",
                brandServe:"",
                brandLogoe:"",
                brandDetali2Name:"",
                time:"",
                currentDate:"",
                mileage:"",
                Ymileage:"",
                city:"",
                phone:"",
                carDetali:[],
                carDetali2:[],
                carDetali3:[],
                areaList:area,
                showAssessment:false,
                assessment:"",
                showValueN:5,
                showValueW:5,
                showValueC:5,
                showValueG:5,
                modeAssessment:[
                    {name:"内饰评分",showValue:"0"},
                    {name:"外观评分",showValue:"0"},
                    {name:"车况评分",showValue:"0"},
                    {name:"骨架结构",showValue:"0"}
                    ],
                modeAssessmentDetail:""
            };
        },

        methods: {
            toShowAssessment(){
                //车况自评
                let _this=this;
                var assessment="";
                for(var i=0;i<_this.modeAssessment.length;i++){
                    if(_this.modeAssessment[i].showValue!=0){
                        assessment=assessment+_this.modeAssessment[i].name+_this.modeAssessment[i].showValue+" ";
                    }
                    if(i+1==_this.modeAssessment.length){
                        _this.assessment=assessment;
                        _this.modeAssessmentDetail=JSON.parse(JSON.stringify(_this.modeAssessment));
                    }
                }
                _this.showAssessment=false;
                //console.log(_this.modeAssessment)
            },
            mainCityTo(picker,value,index){
                //省份
                let _this=this;
                //console.log(picker,value,index)
                _this.provId[0].idCity=_this.detailCity[index].id;
                _this.provId[0].name=_this.detailCity[index].name;
                _this.toProvinces();
            },
            mainProvincesTo(picker,value,index){
                //城市
                let _this=this;
                //console.log(picker,value,index)
                _this.provId[1].idProvinces=_this.detailProvinces[index].id;
                _this.provId[1].name=_this.detailProvinces[index].name;

                console.log(_this.provId,_this.provId2)
            },
            carCity(){
                let _this=this;
                _this.showCity=false;
                _this.city=_this.provId[0].name+'-'+_this.provId[1].name;
                _this.provId2=JSON.parse(JSON.stringify(_this.provId));
                //console.log(_this.provId,_this.provId2)
            },
            toMember(val) {
                let _this=this;
                let Ymileage=_this.Ymileage;
                if(val == '.'){
                    val = '';
                }
                let arr;
                arr = val.split(".");
                arr[0]=arr[0]+"";
                arr[1]=arr[1]+"";
                if(arr[1] == "undefined"){
                    arr[1]="";
                }
                //console.log(Ymileage,val,arr,arr[0].length,arr[1].length)
                if(arr[0].length > 3 || arr[1].length > 2){
                    _this.mileage=Ymileage;
                }else{
                    _this.Ymileage=val;
                }

            },
            toValuation() {
                //一键评估
                var _this=this;
                var brand=_this.brand;
                var time=_this.time;
                var mileage=_this.mileage;
                var name=_this.city;
                var phone=_this.phone;
                //var information=_this.information;

                if(brand == ""){
                    //alert("请选择车型")
                    Toast('请选择车型')
                    return false;
                }else if(time == ""){
                    //alert("请选择车龄")
                    Toast('请选择车龄')
                    return false;
                }else if(mileage == ""){
                    //alert("请填写行驶里程")
                    Toast('请填写行驶里程')
                    return false;
                }else if(name == ""){
                    //alert("请填写卖车城市")
                    Toast('请填写卖车城市')
                    return false;
                }else if(phone == ""){
                    //alert("请填写联系电话")
                    Toast('请填写联系电话')
                    return false;
                }

                for(var i=0;i<_this.modeAssessmentDetail.length;i++){
                    if(_this.modeAssessmentDetail[i].showValue==0){
                        Toast('请给'+_this.modeAssessmentDetail[i].name+'评分')
                        return false;
                    }
                }

                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!myreg.test(phone)) {
                    Toast('手机号有误')
                    return false;
                }else if (phone.length < 11) {
                    Toast('手机号长度有误')
                    return false;
                }

                var carModelId=_this.brandServe;
                var sellCarCityId=_this.provId2[1].idProvinces;
                var idCity=_this.provId2[0].idCity;
                request({
                    url: '/used_car/retail/valuation/evaluate',
                    method: 'POST',
                    data:
                    {
                        "brandLogo": _this.brandLogoe,
                        "carModel": brand,
                        "carModelId": carModelId,
                        "mileage": mileage,
                        "mobile": phone,
                        "registrationTime": _this.currentDate,
                        "sellCarCity": _this.provId2[1].name,
                        "sellCarCityId": sellCarCityId,
                        "sellCarProvince": _this.provId2[0].name,
                        "sellCarProvinceId": idCity,
                        "vehicleEvaluation": {
                        "accident": _this.modeAssessmentDetail[3].showValue,
                            "grade": _this.modeAssessmentDetail[2].showValue,
                            "inner": _this.modeAssessmentDetail[0].showValue,
                            "outer": _this.modeAssessmentDetail[1].showValue
                        }
                    }
                }).then(res=>{
                    //console.log(res,_this)
                    let detail={};
                    if(res.data.industryPurchasePrice == null){
                            detail={
                            brandLogo:_this.brandLogoe,
                            carModel:brand,
                            mileage:mileage,
                            mobile:phone,
                            registrationTime: _this.currentDate,
                            sellCarCity:_this.provId2[1].name,
                            sellCarProvince:_this.provId2[0].name,
                            valuationDetail:""
                        };
                    }else{
                        detail={
                            brandLogo:_this.brandLogoe,
                            carModel:brand,
                            mileage:mileage,
                            mobile:phone,
                            registrationTime: _this.currentDate,
                            sellCarCity:_this.provId2[1].name,
                            sellCarProvince:_this.provId2[0].name,
                            valuationDetail:res.data.industryPurchasePrice
                        };
                    }

                    detail=JSON.stringify(detail);
                    _this.$router.push({ path: '/Collect/KeyValuation', query: { detail:detail }})
                });

                //this.$router.push('/Collect/KeyValuation');
            },
            onClickLeft() {
                this.$router.push('/Collect');
            },
            onConfirm(v) {
                console.log(v)
                this.city = v[0].name+'-'+v[1].name;
                //this.city = value;
                this.show = false;
            },
            onConfirmTime(value) {
                this.currentDate=value.getTime();
                this.time = new Date(value).getFullYear()+'-'+(new Date(value).getMonth()+1)+'-'+new Date(value).getDate();
                this.showTime = false;
            },
            bind(){
                var _this=this;
                _this.show2 = true;

                request({
                    url: '/used_car/retail/valuation/brand/list',
                    method: 'GET'
                }).then(res=>{
                    //console.log(res,"cs")
                    var res=res.data;
                    var list=[],itme=[];
                    for(var i=0;i<res.length;i++){
                        if(list.indexOf(res[i].letter)==-1){
                            list.push(res[i].letter);
                        }
                    }
                    list=list.sort();
                    for(var j=0;j<list.length;j++){
                        var item2=[];
                        var obc={};
                        for(var x=0;x<res.length;x++){
                            if(res[x].letter == list[j]){
                                var obj={};
                                obj={brandName: res[x].brandname ,brandLogo:res[x].picurl ,brandId:res[x].id };
                                item2.push(obj);
                            }
                        }
                        obc={letter:list[j],mian:item2};
                        itme.push(obc);
                    }
                    _this.carDetali=itme;
                });
            },
            trademark(value,L,N){
                console.log(value,L,N)
                var _this=this;
                _this.show3 = true;

                request({
                    url: '/used_car/retail/valuation/series/list',
                    method: 'GET',
                    data:{
                        brandId:value
                    }
                }).then(res=>{
                    //console.log(res,"cs")

                    var res=res.data;
                    for(var i=0;i<res.length;i++){
                        res[i].brandLogo=res[i].brandLogo;
                    }
                    _this.brandLogoe=L;
                    _this.brandDetali2Name=N;
                    _this.carDetali2=res;
                });

            },
            Vehicle(value){
                //console.log(value,"车型")
                var _this=this;

                request({
                    url: '/used_car/retail/valuation/model/list',
                    method: 'GET',
                    data:{
                        seriesId:value
                    }
                }).then(res=>{
                    if(res.data==null){
                        Toast('暂无录入车型');
                        return false;
                    }
                    _this.show4 = true;
                    console.log(res)
                     var res=res.data;
                     _this.carDetali3=res;
                 });

            },
            models(v,e){
                //console.log(v,e)
                var _this=this;
                _this.show2 = false;
                _this.show3 = false;
                _this.show4 = false;
                _this.brand=e;
                _this.brandServe=v;
            },
            toProvinces(){
                var _this=this;
                request({
                    url: '/used_car/retail/valuation/city/list',
                    method: 'GET',
                    data:{
                        provId:_this.provId[0].idCity
                    }
                }).then(res=>{
                    console.log(res)

                    var res=res.data;
                    var item=[];
                    for(var i=0;i<res.length;i++){
                        item.push(res[i].name);
                    }

                    _this.mainProvinces=item;
                    _this.detailProvinces=res;
                    _this.provId[1].idProvinces=res[0].id;
                    _this.provId[1].name=res[0].name;
                })
            }
        },
        mounted: function () {
            var _this=this;
            request({
                url: '/used_car/retail/valuation/province/list',
                method: 'GET'
            }).then(res=>{
                //console.log(res)

                var res=res.data;
                var item=[];
                for(var i=0;i<res.length;i++){
                    item.push(res[i].name);
                }
                //console.log(item)
                _this.mainCity=item;
                _this.detailCity=res;
                _this.provId[0].idCity=res[0].id;
                _this.provId[0].name=res[0].name;
                _this.toProvinces();
            })
        }
    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #fff;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }
  .van-cell{
    padding: 0 .405rem;
    height: 1.377rem;
    font-size: 0.378rem;
  }

  .carDetali{
    font-size: .45rem;
  }
  .carDetali .carFor .carTitle{
    line-height: .667rem;
    background: #F2F2F2;
    padding-left: .4rem;
    color: #999;
  }
  .carDetali .carFor ul li{
    line-height: 1.5rem;
  }
  .carDetali .carFor ul img{
    width: 1rem;
    height: 1rem;
  }
  .carDetali .carFor ul div{
    border-bottom: 1px solid #E5E5E5;
    width: 100%;
    color: #333;
  }

  .carDetali2 .carTitle{
    line-height: 1.8rem;
    font-size: .6rem;
  }
  .carDetali2 .carTitle img{
    width: 1.2rem;
    height: 1.2rem;
    padding: 0 .3rem;
  }
  .carDetali2 ul{
    padding-left: .3rem;
    border-top: .2rem solid #F2F2F2;
  }
  .carDetali2 ul li{
    line-height: 1.2rem;
    font-size: .45rem;
    color: #333;
    border-bottom: 1px solid #E5E5E5;
  }

  .carDetali3 .carFor .carTitle{
    line-height: .667rem;
    background: #F2F2F2;
    padding-left: .4rem;
    color: #999;
    font-size: .45rem;
  }
  .carDetali3 .carFor ul{
    padding-left: .6rem;
    font-size: .4rem;
    color: #333;
  }
  .carDetali3 .carFor ul li{
    line-height: .6rem;
    margin: .2rem 0;
  }
</style>
